import { NeedsHistoryEntryDto } from '@act/shared/data-transfer-objects';
import { callsAppSelectors } from 'redux/slices/callsSlice';
import { userAppSelectors } from 'redux/slices/usersSlice';
import {
  StyledHistoryEntry,
  StyledHistoryEntrySubheader,
  getHistoryEntryDateLine,
} from './history-display';

interface ResourceDetailsHistoryProps {
  historyEntry: NeedsHistoryEntryDto;
}

export const CallHistoryEntry = ({
  historyEntry,
}: ResourceDetailsHistoryProps) => {
  const call = callsAppSelectors.useSelectCallById(historyEntry.callId);
  const creator = userAppSelectors.useSelectUserById(call?.originator?.userId);
  const creatorName = creator?.name;

  return (
    <StyledHistoryEntry
      header={`Resource Called: ${historyEntry.resource.title}`}
      content={
        <StyledHistoryEntrySubheader>
          {getHistoryEntryDateLine(historyEntry?.createdAt, creatorName)}
        </StyledHistoryEntrySubheader>
      }
    />
  );
};
